// Ultimate Card Game (UCG) - Command Queue
//
// Every state-changing player action (play a card, discard, activate a CO
// power, upgrade a unit...) goes through here instead of mutating the
// engine directly from a click handler. That's what makes two things
// possible later without touching engine code again:
//   - an online match, where the "player" issuing commands might be a
//     network peer instead of a local click
//   - a replay, which is just this same command list saved and re-drained
//     into a fresh simulation
//
// For now (single-player only) commands are drained and applied once per
// tick, immediately before that tick's simulation step - same timing as
// today's direct calls, just funneled through one place.

export class CommandQueue {
  constructor() {
    this._pending = [];
  }

  enqueue(command) {
    this._pending.push(command);
  }

  drain() {
    if (this._pending.length === 0) return this._pending;
    const commands = this._pending;
    this._pending = [];
    return commands;
  }
}
